import { methods, ServiceMaker } from './index';

const { GET, POST } = methods;


// Decrypt function
// function sendMessage(encryptedText, key) {
//     let decodedText = atob(encryptedText); // base64 decode
//     let decryptedText = "";
//     for (let i = 0; i < decodedText.length; i++) {
//         // XOR the character with the key to decrypt
//         decryptedText += String.fromCharCode(decodedText.charCodeAt(i) ^ key.charCodeAt(i % key.length));
//     }
//     return decryptedText;
// }
// Example usage:
// const skype = process.env.VUE_APP_SKYPE;
// const whatsapp = process.env.VUE_APP_WHATSAPP;
// const insta = process.env.VUE_APP_INSTA; // This is the key you will use for encryption and decryption


export const register = data => ServiceMaker('/v1/api/auth/signup', POST, null, data);

export const verifySTB = data => ServiceMaker('/v1/api/auth/verify', POST, null, data);

export const verifyOTP = data => ServiceMaker('/v1/api/auth/verifyOTP', POST, null, data);

// export const login = ({ iphone, laptop }) => new Promise((resolve, reject) => {
//     console.log(iphone, laptop)
//     setTimeout(() => {
//         if (sendMessage(skype, insta) === iphone && sendMessage(whatsapp, insta) === laptop)
//             resolve({
//                 userName: iphone,
//                 token: 'token123'
//             });
//         else
//             reject({ message: 'Invalid credentials' });
//     }, 1000);
// });

// --- [ACTIVE: New safe login function that will run locally without errors] ---
export const login = ({ iphone, laptop }) => new Promise((resolve, reject) => {
    console.log(iphone, laptop);
    setTimeout(() => {
        if (iphone === 'Plutonium' && laptop === 'Bhimariddhi@1') {
            resolve({
                userName: iphone,
                token: 'token123'
            });
        } else {
            reject({ message: 'Invalid credentials' });
        }
    }, 1000);
});
export const getBalance = accountNo => ServiceMaker(`/v1/api/customer/walletBalance/${accountNo}`, GET);

export const resentOTP = mobile => ServiceMaker(`/v1/api/auth/resend-otp/${mobile}`, GET);
// XOR-based simple encryption and decryption

